import styled from 'styled-components';
import { Swiper } from 'swiper/react';

export const AboutSlider = styled(Swiper)`
      @media screen and (max-width: 600px) {
            height: 240px;
      }
`;
